// extracted by mini-css-extract-plugin
module.exports = {"meaning_display":"styles_meaning_display__16z9i"};